import { render } from "./OperationManage.vue?vue&type=template&id=b825a310&scoped=true"
import script from "./OperationManage.vue?vue&type=script&lang=js"
export * from "./OperationManage.vue?vue&type=script&lang=js"

import "./OperationManage.vue?vue&type=style&index=0&id=b825a310&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b825a310"]])

export default __exports__